import { render, staticRenderFns } from "./msTab.vue?vue&type=template&id=53c5f770&scoped=true"
import script from "./msTab.vue?vue&type=script&lang=js"
export * from "./msTab.vue?vue&type=script&lang=js"
import style0 from "./msTab.vue?vue&type=style&index=0&id=53c5f770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c5f770",
  null
  
)

export default component.exports